import React from 'react'
import styled from 'styled-components'

import { Container } from 'app/components/ui/Container'
import { Title } from 'app/components/ui/Title'
import { Text } from 'app/components/ui/Text'
import { themeEstra } from 'src/styles/themeEstra'

import {
  HeaderClipper,
  HeaderClipperBgPosition,
  HeaderClipperWaveVariant,
} from '../HeaderClipper'

export type SubTitleVariant = 'login_signup' | 'quotations' | 'quotation_detail'

interface Props {
  title?: string
  subtitle?: string
  subtitleVariant?: SubTitleVariant
  bgColor?: string

  bgImage?: string
  bgPosition?: HeaderClipperBgPosition
  variant: HeaderClipperWaveVariant
}

export const HeaderWave: React.FC<Props> = ({
  title,
  subtitle,
  subtitleVariant,
  bgColor,
  bgImage,
  bgPosition,
  variant,
}) => {
  const getSubtitleVariant = () => {
    switch (subtitleVariant) {
      case 'login_signup':
        return (
          <Title size={2} color={themeEstra.color.primari.grigioEstra}>
            {subtitle}
          </Title>
        )
      case 'quotations':
        return (
          <Text variant='s24' color={themeEstra.color.primari.grigioEstra}>
            {subtitle}
          </Text>
        )
      case 'quotation_detail':
        return (
          <Title size={3} color={themeEstra.color.primari.grigioEstra}>
            {subtitle}
          </Title>
        )
      default:
        return (
          <Title size={2} color={themeEstra.color.primari.grigioEstra}>
            {subtitle}
          </Title>
        )
    }
  }

  return (
    <Wrapper
      waveVariant={variant}
      bgImage={bgImage}
      bgSize='cover'
      bgColor={bgColor || themeEstra.color.neutri.grigioBg}
      bgPosition={`${bgPosition} center`}
    >
      <Container>
        <Body>
          <HeaderTitle color={themeEstra.color.primari.neroEstra}>
            {title}
          </HeaderTitle>
          {getSubtitleVariant()}
        </Body>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled(HeaderClipper)`
  text-align: center;
`

const Body = styled.div`
  margin: 0 auto;
  @media (min-width: ${themeEstra.bp.tablet}) {
    padding: 2rem 0;
  }
`

const HeaderTitle = styled(Title)`
  margin-bottom: 1rem;
`
